<template>
  <div class="otp-pay">
    <!-- 加载中 -->
    <div class="otp-loading" v-if="isLoading">
      <div class="otp-loading-img-box">
        <img class="otp-loading-img" src="@/assets/prokash/pending.gif" alt="" />
      </div>
      <div class="otp-loading-text">Please wait...</div>
    </div>

    <!-- 错误 -->
    <div class="otp-over fail" v-if="isFailed && !isConfirming">
      <div class="otp-over-icon">✕</div>
      <div class="otp-over-text">Payment Failed</div>
      <div class="otp-over-desc">{{ failMessage }}</div>
      <div @click="$emit('expired')" class="otp-over-btn">Close</div>
    </div>

    <!-- OTP 输入 -->
    <div class="otp-container" v-if="!isLoading && !isFailed && !isConfirming && !isOver">
      <div class="otp-header">
        <div class="otp-title">SMS Verification</div>
        <div class="otp-desc">Please enter the 6-digit verification code sent to your phone <b>{{ userMobileDisplay }}</b></div>
      </div>

      <div class="otp-amount-box">
        <div class="otp-amount-label">Amount</div>
        <div class="otp-amount-value">
          <span>{{ currencyCode }}</span>
          <span class="otp-amount-num">{{ formattedPaymentAmount }}</span>
        </div>
      </div>

      <div class="otp-input-box">
        <input
          v-model="otpCode"
          class="otp-input"
          type="tel"
          maxlength="6"
          placeholder="Enter OTP code"
          @input="onOtpInput"
        />
      </div>

      <div class="otp-submit-btn" @click="submitOtp" :class="{ disabled: otpCode.length < 6 || submitting }">
        <span>{{ submitting ? 'Confirming...' : 'Confirm Payment' }}</span>
      </div>
    </div>

    <!-- 确认中 -->
    <div class="otp-pending" v-if="isConfirming">
      <div class="otp-pending-text">Verifying...</div>
      <div class="otp-pending-img-box">
        <img class="otp-pending-img" src="@/assets/prokash/pending.gif" alt="" />
      </div>
    </div>

    <!-- 成功 -->
    <div class="otp-over success" v-if="isOver">
      <div class="otp-over-icon">✓</div>
      <div class="otp-over-text">Payment Successful</div>
      <div @click="back" class="otp-over-btn">Close</div>
    </div>
  </div>
</template>

<script>
import logic from "./index.js";
export default {
  name: "TwoPhaseOtpMoblie",
  mixins: [logic],
};
</script>

<style lang="scss" scoped>
.otp-pay {
  min-height: 100vh;
  background: #f5f5f5;
}

.otp-loading {
  text-align: center;
  padding-top: 60px;

  .otp-loading-img-box {
    display: flex;
    justify-content: center;

    .otp-loading-img {
      width: 250px;
      height: 250px;
    }
  }

  .otp-loading-text {
    font-size: 16px;
    color: #555;
    transform: translateY(-60px);
  }
}

.otp-container {
  padding: 40px 20px 0;
}

.otp-header {
  text-align: center;
  margin-bottom: 24px;
}

.otp-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.otp-desc {
  font-size: 13px;
  color: #888;
  line-height: 1.4;

  b {
    color: #DC811D;
  }
}

.otp-amount-box {
  text-align: center;
  margin-bottom: 24px;
}

.otp-amount-label {
  font-size: 13px;
  color: #888;
  margin-bottom: 4px;
}

.otp-amount-value {
  font-size: 14px;
  color: #524535;
  font-weight: 500;
}

.otp-amount-num {
  font-size: 18px;
  color: #DC811D;
  margin-left: 4px;
}

.otp-input-box {
  margin-bottom: 20px;
}

.otp-input {
  width: 100%;
  height: 48px;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 0 16px;
  font-size: 18px;
  text-align: center;
  letter-spacing: 8px;
  outline: none;
  box-sizing: border-box;

  &:focus {
    border-color: #DC811D;
  }

  &::placeholder {
    letter-spacing: 0;
    font-size: 14px;
    color: #bbb;
  }
}

.otp-submit-btn {
  margin: 0 auto;
  width: 200px;
  height: 45px;
  background: linear-gradient(180deg, #ecd2a1 0%, #d4b077 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  span {
    font-size: 15px;
    font-weight: 500;
    color: #996a30;
  }
}

.otp-pending {
  text-align: center;
  padding-top: 60px;

  .otp-pending-text {
    font-size: 20px;
    font-weight: 500;
    color: #555;
  }

  .otp-pending-img-box {
    display: flex;
    justify-content: center;
    transform: translateY(-30px);

    .otp-pending-img {
      width: 250px;
      height: 250px;
    }
  }
}

.otp-over {
  text-align: center;
  padding-top: 60px;

  .otp-over-icon {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin: 0 auto 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    color: #fff;
  }

  &.success .otp-over-icon {
    background: #52c41a;
  }

  &.fail .otp-over-icon {
    background: #ff4d4f;
  }

  .otp-over-text {
    font-size: 22px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  &.success .otp-over-text {
    color: #52c41a;
  }

  &.fail .otp-over-text {
    color: #ff4d4f;
  }

  .otp-over-desc {
    font-size: 14px;
    color: #888;
    margin-bottom: 20px;
  }

  .otp-over-btn {
    cursor: pointer;
    margin: 30px auto 0;
    width: calc(100% - 40px);
    height: 45px;
    background: linear-gradient(180deg, #ecd2a1 0%, #d4b077 100%);
    border-radius: 8px;
    font-size: 15px;
    font-weight: 500;
    color: #996a30;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
